import { render, staticRenderFns } from "./SurveyAffiliateTable.vue?vue&type=template&id=ac1a98d4&"
import script from "./SurveyAffiliateTable.vue?vue&type=script&lang=ts&"
export * from "./SurveyAffiliateTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports